import React from "react";
import { useState, useEffect, useRef } from "react";
import { hasAuthParams, useAuth as useOidcAuth } from 'react-oidc-context';
import Unauthenticated from "./Unauthenticated";
import "../css/PageComponent.css";
import Title from "./Title";
import Header from "./Header";
import PageFooter from "./PageFooter";
import Search from "./Search";
import FCList from "./FCList";
import FCDetail from "./FCDetail";
import FCUpdate from "./FCUpdate";
import FCDelete from "./FCDelete";
import FCAdd from "./FCAdd";
import Spinner from "./Spinner";
import {verifyRoles, parseJwt} from '../api/SecurityUtil'
import { retrieveByEmail } from "../api/mdmAPI";
import { refreshAccessToken } from "../api/oauthAPI";
import Alert from "./Alert";
import FeatherIcon from "feather-icons";

export default function PageComponents() {
    const [isCSR, setIsCSR] = useState(null);
    const [isUser, setIsUser] = useState(null);
    const [fcResponse, setFcResponse] = useState(null);
    const [fcDisplayResponse, setFcDisplayResponse] = useState(null);
    const [fcEditMode, setFcEditMode] = useState(false);
    const [fcDeleteMode, setFcDeleteMode] = useState(false);
    const [spinnerActive, setSpinnerActive] = useState(true);
    const [fcAddMode, setFcAddMode] = useState(false);
    const [userEid, setUserEid] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [address, setAddress] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [isDemographicAdd, setIsDemographicAdd] = useState(true);
    const [viewPersonResponse, setViewPersonResponse] = useState();
    const [globalAlert, setGlobalAlert] = useState({
        id: "",
        type: "",
        message: "",
        hidden: true,
        data: "",
      });
    
    let validAccessToken = false;
    const { user, isLoading, isAuthenticated, activeNavigator, signinRedirect, error } = useOidcAuth();
    const hasRedirectedRef = useRef(false);

    useEffect(() => {
        if (error) {
            console.error('OIDC auth error', error);
            return;
        }

        if (!hasRedirectedRef.current && !isLoading && !isAuthenticated && !activeNavigator && !hasAuthParams()) {
            hasRedirectedRef.current = true;
            signinRedirect().catch((err) => {
                console.error('OIDC sign-in redirect failed', err);
                hasRedirectedRef.current = false;
            });
        }
    }, [activeNavigator, error, isAuthenticated, isLoading, signinRedirect]);

    async function getUserEid(email) {
        let token = user.access_token;
        if (user.expired) {
            token = await refreshAccessToken(user.refresh_token);
        }
        // needed for using the app with our alt accounts to look up our correct EID as a user
        email = email.replace("-alt.",".");
        email = email.replace("-ER.",".");
        email = email.replace("-P@","@");
        let resp = await retrieveByEmail(token, email);
        if (resp.personSummaries.length > 0) {
            return resp.personSummaries[0].enterpriseId;
        } else {
            setGlobalAlert(
                {
                  id: "email-not-Found-alert",
                  type: "error",
                  message:
                  "Could not find the EID for email. " + email,
                  hidden: false,
                }
              )        
        }
    }

    useEffect(() => {
        async function getData() {
            if (validAccessToken) {
                if(isCSR === null) {
                    let mytoken = parseJwt(user.access_token); 
                    let csrUser = false;
                    csrUser = await verifyRoles(mytoken.roles, "AdminRole");
                    setIsCSR(csrUser);
                    let generalUser = false;
                    generalUser = await verifyRoles(mytoken.roles, "UserRole")
                    setIsUser(generalUser);
                    setUserEmail(mytoken.preferred_username);
                    let eid = undefined;
                    eid = await getUserEid(mytoken.preferred_username);
                    if (eid !== undefined) {
                        setUserEid(eid);
                    }
                    setSpinnerActive(false);
                } 
            }
        }
        getData();
    }, );

    if (user != null) {
        if (user.access_token != null) {
            validAccessToken = true;
        }
    }
    FeatherIcon.replace();
    return (
        <div id="pageComponents" className="container">
            {user == null
                ? <div>
                    <Spinner spinnerActive={spinnerActive}/>
                </div>
                :
                <div>
                    {validAccessToken && (isCSR || isUser)
                        ? <div>
                            <Header />
                            <Title />
                            <Alert globalAlert={globalAlert} setGlobalAlert={setGlobalAlert} />
                            {fcResponse === null && fcDisplayResponse == null && userEid != null && <Search user={user} setData={setFcResponse} setSpinnerActive={setSpinnerActive} setSearchValue={setSearchValue} setGlobalAlert={setGlobalAlert} setAddress={setAddress}/>}
                            {fcResponse !== null && fcDisplayResponse == null && !fcAddMode && address!== null && <FCList user={user} fcData={fcResponse} admin={isCSR} setData={setFcResponse} setFcDisplayResponse={setFcDisplayResponse} setFcAddMode={setFcAddMode} setFcEditMode={setFcEditMode} setSpinnerActive={setSpinnerActive} searchValue={searchValue} address={address} setGlobalAlert={setGlobalAlert}/>}
                            {fcDisplayResponse !== null && !fcEditMode && !fcAddMode && !fcDeleteMode && <FCDetail fcDisplayResponse={fcDisplayResponse} setFcDisplayResponse={setFcDisplayResponse} fcresponse={fcResponse} setfcResponse={setFcResponse} setFcEditMode={setFcEditMode} setFcAddMode={setFcAddMode} setSpinnerActive={setSpinnerActive}  searchValue={searchValue} fcDeleteMode={fcDeleteMode} setFcDeleteMode={setFcDeleteMode} admin={isCSR} setGlobalAlert={setGlobalAlert}/>}
                            {fcDisplayResponse !== null && fcEditMode && <FCUpdate user={user} setFcDisplayResponse={setFcDisplayResponse} fcDisplayResponse={fcDisplayResponse} fcResponse={fcResponse} fcEditMode={fcEditMode} setFcEditMode={setFcEditMode} setSpinnerActive={setSpinnerActive} userEid={userEid}  searchValue={searchValue} admin={isCSR} setGlobalAlert={setGlobalAlert}/> }
                            {fcDisplayResponse !== null && fcDeleteMode && <FCDelete user={user} setFcDisplayResponse={setFcDisplayResponse} fcDisplayResponse={fcDisplayResponse} fcResponse={fcResponse} setfcResponse={setFcResponse} fcDeleteMode={fcDeleteMode} setFcDeleteMode={setFcDeleteMode} setSpinnerActive={setSpinnerActive} userEid={userEid}  searchValue={searchValue} setGlobalAlert={setGlobalAlert}/>}
                            {fcResponse !== null && !fcEditMode && !fcDeleteMode && fcAddMode && 
                                <FCAdd user={user} setFcDisplayResponse={setFcDisplayResponse} fcResponse={fcResponse}  setfcResponse={setFcResponse} 
                                    setFcAddMode={setFcAddMode} setFcEditMode={setFcEditMode} setSpinnerActive={setSpinnerActive} CSR={isCSR} userEid={userEid}
                                    searchValue={searchValue} setGlobalAlert={setGlobalAlert} isDemographicAdd={isDemographicAdd} setIsDemographicAdd={setIsDemographicAdd} 
                                    viewPersonResponse={viewPersonResponse} setViewPersonResponse={setViewPersonResponse} address={address} requesterEmail={userEmail}/>}
                            <Spinner spinnerActive={spinnerActive}/>

                            <PageFooter />
                        </div>

                        : <div>
                            <Unauthenticated />
                        </div>
                    }
                </div>
            }
        </div>
    );
}
